import { createApi } from '@reduxjs/toolkit/query/react';

import { ICourseShelf, IKeepLearningCourse } from '@/interfaces/course';
import { ISavedLesson } from '@/interfaces/lesson';
import { IBannerShowcaseWithConfig } from '@/interfaces/upsell';

import { axiosBaseQuery } from './query';

export const resumeApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'resumeApi',
  tagTypes: ['getKeepWatchingShelf'],
  endpoints(build) {
    return {
      getKeepWatchingShelf: build.query<IKeepLearningCourse[], unknown>({
        query: () => ({
          formatResponse: response => response.data.data,
          url: '/learner/keep-watching'
        }),
        providesTags: ['getKeepWatchingShelf']
      }),
      getRecentlySavedShelf: build.query<ISavedLesson[], unknown>({
        query: () => ({
          formatResponse: response => response.data.data,
          url: '/learner/savedlessons',
          params: {
            page: 1,
            size: 12,
            order: 'ASC'
          }
        })
      }),
      getCourseShelf: build.query<ICourseShelf[], unknown>({
        query: () => ({
          formatResponse: response => response.data.data,
          url: '/learner/resume/courses'
        })
      }),
      getBanner: build.query<IBannerShowcaseWithConfig, unknown>({
        query: () => ({
          formatResponse: response => response.data,
          url: '/learner/course/highlights/v2',
          method: 'get'
        })
      })
    };
  }
});

export const {
  useGetKeepWatchingShelfQuery,
  useGetRecentlySavedShelfQuery,
  useGetCourseShelfQuery,
  useGetBannerQuery
} = resumeApi;
